<template>
  <div class="maps">
    <div
      id="map"
      ref="myEchart"
    ></div>
  </div>
</template>
<script>
import "../../node_modules/echarts/map/js/world.js";
export default {
  data() {
    return {};
  },
  methods: {
    initEcharts() {
      var mychartMap = this.$echarts.init(this.$refs.myEchart);
      // var geoCoordMap = {};
      mychartMap.setOption({
        // 标志颜色
        color: "rgb(248, 119, 75)",
        geo: {
          map: "world",
          show: true,
          roam: false, //是否缩放
          aspectScale: 1, //长宽比
          layoutCenter: ["50%", "50%"],
          layoutSize: 1200,
          label: {
            show: false
          },

          itemStyle: {
            borderWidth: 0,
            areaColor: "rgb(21, 135, 124)" //区域颜色
          },
          silent: true //图形是否不响应和触发鼠标事件
        },
        // 添加视觉映射组件
        visualMap: {
          type: "piecewise", // 连续型
          min: 0,
          max: 1000000,
          itemWidth: 12,
          itemHeight: 12,
          itemSymbol: "roundRect",
          effectType: "ripple",
          bottom: 30,
          left: 60,
          realtime: false,
          calculable: true,
          pieces: [
            {
              gte: 0,
              lte: 35,
              label: this.$t('main.open'),
              color: "rgb(8, 193, 224)"
            },
            {
              gte: 35,
              lte: 105,
              label: this.$t('main.overseas'),
              color: "rgb(248, 119, 75)"
            }
          ],
          inRange: {
            symbol: "circle"
          },
          hoverLink: true,
          textStyle: {
            color: "#fff"
          },
          selectedMode: "multiple" //多选
        },
        series: [
          {
            name: "", //名称
            type: "effectScatter",
            mapType: "world",
            coordinateSystem: "geo", // series坐标系类型
            symbolSize: 9,
            legendHoverLink: false,
            effectType: "ripple",
            rippleEffect:{
              scale:4
            },
            cursor: "default",
            data: this.$t('main.data'),
            label: {
              show: true, //名称显示
              formatter: function(params) {
                return params.name;
              },
              textStyle: {
                color: "rgb(173, 216, 235)",
                align: "left",
                fontSize: 10,
                padding: [0, 0, 0, 10]
              }
            },
            emphasis: {
              show: false
            },
            itemStyle: {
              borderColor: "rgb(236, 238, 240)"
            }
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.maps {
  #map {
    width: 100%;
    height: 600px;
    text-align: center;
  }
}
</style>
